import request from "@/utils/request";
  
export function printStationApi(data) {
  return request({
    url: "?c=pp&a=station&do=print",
    method: "post",
    data
  });
}

